module.exports = __webpack_public_path__ + "img/Data storage_Outline.cd713059.png";